import { useRecoilState } from 'recoil';

import { CUSTOM_ALLOCATION_TYPE } from '_constants/allocationTypes';

import {
    addressesState,
    distributionTypeState,
} from 'store/state';
import { webLibSdk } from 'helpers';
import toastAlert from 'components/UI/Alert';

const useAddressesActions = () => {
    const [appAddresses, setAddresses] = useRecoilState(addressesState);
    const [distributionType] = useRecoilState(distributionTypeState);

    const getAddresses = async () => {
        try {
            const isConnected = await webLibSdk.isConnected();

            const currentAddress = isConnected ? await webLibSdk.currentAddress() : '';
            const distProps = appAddresses.contract || await webLibSdk[distributionType === CUSTOM_ALLOCATION_TYPE ? 'customDistributionProperties' : 'distributionProperties']();
            const [distributionAddress, customDistribution] = webLibSdk.getAllocationDistributionAddresses();
            const addresses = {
                contract: appAddresses.contract || distProps.fasttokenAddress,
                distribution: distributionAddress,
                customDistribution,
                current: currentAddress,
            };
            setAddresses(addresses);

            return addresses;
        } catch (err) {
            console.log(err);
            toastAlert({
                type: 'error',
                customMessage: err,
            });
        }
    };

    return {
        getAddresses,
    };
};

export default useAddressesActions;
